import { useCallback } from "react";
import { LoaderFunctionArgs, redirect, useBlocker } from "react-router";

import { AuthService, User } from "./auth";
import { Organization } from "./contexts/organization";
import { createApiClient } from "./api-client";

export function usePromptBeforeNavigation({ msg, block = true }: { msg: string; block: boolean }) {
  useBlocker(useCallback(() => (block ? !window.confirm(msg) : false), [msg, block]));
}

async function getActiveOrganizationId(
  user: User | undefined,
  availableOrganizations: Array<Organization>
) {
  let activeOrganizationId = availableOrganizations[0].id;

  try {
    const userSettings = localStorage.getItem(user!.id);
    if (userSettings) {
      const activeOrgaIdFromLS = JSON.parse(userSettings).activeOrganizationId;
      if (availableOrganizations.find((o) => o.id === activeOrgaIdFromLS)) {
        activeOrganizationId = activeOrgaIdFromLS;
      }
    }
  } catch {
    // Intentionally left empty
  }

  return activeOrganizationId;
}

export async function redirectToActiveOrganizationLoader(_: LoaderFunctionArgs) {
  const apiClient = createApiClient(AuthService.getTokenSilently);
  const activeOrganizationId = await getActiveOrganizationId(
    await AuthService.user(),
    await apiClient.getOrganizations()
  );

  return redirect(`/${activeOrganizationId}/home`);
}

export async function redirectToAppWithActiveOrganizationLoader({ params }: LoaderFunctionArgs) {
  const { appName } = params;
  const apiClient = createApiClient(AuthService.getTokenSilently);
  const activeOrganizationId = await getActiveOrganizationId(
    await AuthService.user(),
    await apiClient.getOrganizations()
  );

  return redirect(`/${activeOrganizationId}/${appName ?? "home"}`);
}

export function convertRouteModule(module: any) {
  const { clientLoader, clientAction, default: Component, ...rest } = module;
  return {
    ...rest,
    loader: clientLoader,
    action: clientAction,
    Component,
  };
}
